import React from 'react';

const Details: React.FC = () => {
  const [accommodationsOpen, setAccommodationsOpen] = React.useState<boolean>(false);
  return (
    <div className="py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-wedding text-gray-900 mb-6">
            Wedding Details
          </h1>
          <p className="text-xl text-gray-600">
            Everything you need to know about our special day
          </p>
        </div>

        <div className="max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl font-wedding text-gray-900 mb-8 text-center">
            Schedule
          </h2>
          <ol className="relative border-l-2 border-primary-200 ml-4 space-y-10">
            <li className="pl-6 relative">
              <span className="absolute -left-[11px] top-1 h-5 w-5 rounded-full bg-primary-600 ring-4 ring-white" />
              <p className="text-sm uppercase tracking-wide text-primary-700 font-medium">Sunday, August 9, 2026 — 6:30 PM</p>
              <h3 className="text-xl font-wedding text-gray-900 mt-1">Rehearsal Dinner</h3>
              <p className="text-gray-600 mt-1">Lodge C, 1 Benner St, Stanley, ID 83278. Join us the night before for a casual dinner — for anyone in town early.</p>
            </li>
            <li className="pl-6 relative">
              <span className="absolute -left-[11px] top-1 h-5 w-5 rounded-full bg-primary-600 ring-4 ring-white" />
              <p className="text-sm uppercase tracking-wide text-primary-700 font-medium">Monday, August 10, 2026 — 1:30 PM</p>
              <h3 className="text-xl font-wedding text-gray-900 mt-1">Wedding Ceremony</h3>
              <p className="text-gray-600 mt-1">Redfish Lake Picnic Area, Redfish Lake Rd, Lowman, ID 83637.</p>
            </li>
            <li className="pl-6 relative">
              <span className="absolute -left-[11px] top-1 h-5 w-5 rounded-full bg-primary-600 ring-4 ring-white" />
              <p className="text-sm uppercase tracking-wide text-primary-700 font-medium">Following the Ceremony</p>
              <h3 className="text-xl font-wedding text-gray-900 mt-1">Photos</h3>
              <p className="text-gray-600 mt-1">Group and family photos will take place right after the ceremony — please stick around!</p>
            </li>
            <li className="pl-6 relative">
              <span className="absolute -left-[11px] top-1 h-5 w-5 rounded-full bg-primary-600 ring-4 ring-white" />
              <p className="text-sm uppercase tracking-wide text-primary-700 font-medium">4:00 PM – 6:00 PM</p>
              <h3 className="text-xl font-wedding text-gray-900 mt-1">Reception Dinner</h3>
              <p className="text-gray-600 mt-1">Redfish Lake Lodge.</p>
            </li>
          </ol>
        </div>

        {/* Additional Information */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="wedding-card">
            <h3 className="text-xl font-wedding text-gray-900 mb-4">
              Dress Code
            </h3>
            <p className="text-gray-600">
              Cocktail attire. We suggest garden party chic - 
              dressy but comfortable for an outdoor celebration. Don't wear white please :)
            </p>
          </div>

          <div className="wedding-card">
            <h3 className="text-xl font-wedding text-gray-900 mb-4">
              Accommodations
            </h3>
            <p className="text-gray-600 mb-4">
              We recommend staying near the lake or the closest town of Stanley. Here are some options in the area.
            </p>
            <button
              type="button"
              onClick={() => setAccommodationsOpen((v) => !v)}
              className="wedding-button-outline text-sm px-3 py-2"
              aria-expanded={accommodationsOpen}
              aria-controls="accommodations-list"
            >
              {accommodationsOpen ? 'Hide options' : 'Show options'}
            </button>
            {accommodationsOpen && (
              <ul id="accommodations-list" className="mt-4 list-disc pl-5 space-y-2 text-primary-700">
                <li><a className="underline hover:text-primary-800" href="https://resnexus.com/resnexus/reservations/book/EA55C8D8-6510-4A31-A259-36EFC017E290" target="_blank" rel="noopener noreferrer">Redfish Lake Lodge</a></li>
                <li><a className="underline hover:text-primary-800" href="https://secure.thinkreservations.com/triangleccabins/reservations?_gl=1*5txgv9*_gcl_aw*R0NMLjE3NTYzMTkyNDEuQ2p3S0NBancyYnJGQmhCT0Vpd0FWSlg1R004OTZiZ3ItcFV5cU9JOFlUUGhEaTlCU2tHUUl6WnF6bEZSM0lZTHBBTzJsNTVMWEFOSk1ob0NiSjBRQXZEX0J3RQ..*_ga*MTA5NzY3MDAxMi4xNzU2MDAxODQ4*_ga_RS66DRQMEX*czE3NTcyMzg4ODYkbzgkZzEkdDE3NTcyMzg4OTUkajUxJGwwJGg2NDgxMTc1Mzk." target="_blank" rel="noopener noreferrer">Triangle C Cabins</a></li>
                <li><a className="underline hover:text-primary-800" href="https://stanleyinn.com/all-rooms/" target="_blank" rel="noopener noreferrer">Stanley High Country Inn</a></li>
                <li><a className="underline hover:text-primary-800" href="https://redfishriversideinn.com/all-accommodations/" target="_blank" rel="noopener noreferrer">Redfish Riverside Inn</a></li>
                <li><a className="underline hover:text-primary-800" href="https://www.airbnb.com/rooms/35992885?check_in=2025-09-28&check_out=2025-10-03&guests=1&adults=2&s=67&unique_share_id=6e8ef947-b821-4f35-b2fd-9347d33376a5/" target="_blank" rel="noopener noreferrer">Stanley Cabin Airbnb</a></li>
                <li><a className="underline hover:text-primary-800" href="https://www.mountainvillage.com/lodging/" target="_blank" rel="noopener noreferrer">Mountain Village Resort</a></li>
              </ul>
            )}
          </div>

          <div className="wedding-card">
            <h3 className="text-xl font-wedding text-gray-900 mb-4">
              Transportation
            </h3>
            <p className="text-gray-600">
              Parking is very limited at the ceremony location, please ride share if able. Parking is available at the venue.
            </p>
          </div>

          <div className="wedding-card">
            <h3 className="text-xl font-wedding text-gray-900 mb-4">
              Gifts
            </h3>
            <p className="text-gray-600">
              No need to bring any gifts — your presence is gift enough. Truly, just having you there means the world to us.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Details; 